import { render, staticRenderFns } from "./fccTodosGrupos.vue?vue&type=template&id=f082ef7a"
import script from "./fccTodosGrupos.vue?vue&type=script&lang=js"
export * from "./fccTodosGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports